<section class="content">
    <app-alerts-components
            [type]="'info'"
            [icon]="'fa fa-info-circle'"
            [id]="'family_info_text'"
            [fontSize]="'0.98rem'"
            [disableClose]="true"
            [message]="'family_info_text' | localise"></app-alerts-components>

    <div class="row">
        <div class="grid-margin column mobile-full third">
            <h4>{{ 'add_family_member' | localise }}</h4>

            <input type="text"
                   [(ngModel)]="search_text"
                   (keyup)="searchTextChanged()"
                   placeholder="{{ 'email_or_name' | localise }} ..."
                   class="form-control"/>

            <ul class="friends-suggestions">
                <li *ngFor="let friend of search_friends">
                    <button
                            (click)="addFriend(friend.email)"
                            class="btn btn-sm btn-success pull-right">{{ 'add' | localise }}</button>
                    <span>{{ friend.first_name }} {{ friend.last_name }}</span>
                </li>
            </ul>
        </div>
        <div class="friends-block grid-margin column mobile-full sixfive-percentage">
            <h4>{{ 'friends' | localise }}</h4>

            <ul class="friends">
                <li *ngFor="let friend of friends">
                    <button
                            (click)="removeFriend(friend.id)"
                            class="btn btn-sm btn-danger pull-right">
                        {{ 'remove' | localise }}
                    </button>
                    <span>{{ friend.friend.first_name }} {{ friend.friend.last_name }}</span>
                </li>
            </ul>

            <app-alerts-components
                    *ngIf="friends.length <= 0"
                    [type]="'warning'"
                    [icon]="'fa fa-exclamation-triangle'"
                    [id]="'no_family'"
                    [title]="'no_users_found' | localise"
                    [disableClose]="true"
                    [message]="'no_friends' | localise"></app-alerts-components>
        </div>
    </div>
</section>
